<template>
	<div class="row">
		<div class="documentation">
			<div class="documentation-container">

				<div id="response_errors" class="response_errors_container" style="display:none"></div>

				<div>

					<nav aria-label="breadcrumb" class="d-none d-xl-block">
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/docs">Документы</a></li>
							<li class="breadcrumb-item"><a href="/docs-edit">Список документов</a></li>
							<li v-if="type == 'create'" class="breadcrumb-item active" aria-current="page">Добавить новую статью</li>
							<li v-if="type == 'update'" class="breadcrumb-item active" aria-current="page">Редактировать статью</li>
						</ol>
					</nav>
					<div class="title-block">
						<div class="title-block__left">
							<div v-if="type == 'create'" class="title-block__title">
								Добавить новую статью
							</div>
							<div v-if="type == 'update'" class="title-block__title">
								Редактировать статью
							</div>
						</div>
					</div>

					<input type="hidden" id="pageIdInput" v-model="pageId">

					<input type="hidden" id="pageSoftwareInput" v-model="pageSoftwareSelected">
					<div class="row mb-4">
						<div class="col-12">
							<v-select
								label="Выберите программу"
								v-model="pageSoftware"
								:items="softwareOptions"
								@update:modelValue="onPageSoftwareChange($event)"
								@update:menu="$removeFocus"
								@click:clear="$removeFocus"
								@click:control="$removeFocus"
								item-title="label"
								item-value="element"
								variant="outlined"
								color="primary"
								density="compact"
								clearable>
								<template #no-data>
									<v-list-item>
										<span>Данные не найдены</span>
									</v-list-item>
								</template>
							</v-select>
						</div>
					</div>

					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Название статьи*</div>
							<input type="text" class="form-control" id="pageNameInput" placeholder="введите название" v-model="pageName">
						</div>
					</div>

					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Выберите родительский документ</div>
							<div class="search-control doc-search-control" :class="parentDocIcon">
								<input type="text" class="search-control__input form-control" placeholder="Поиск" :value="parentDoc"
									@input="resetChoice" @click="openSuggestions" @focus="openSuggestions">
								<button class="search-control__input-btn reset-btn"><svg width="21" height="20" viewBox="0 0 21 20"
										fill="none" xmlns="http://www.w3.org/2000/svg">
										<path
											d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z"
											fill="currentColor"></path>
									</svg>
								</button>
								<ul class="search-suggestions doc-suggestions" :class="{ open: suggestionsOpen }"
									@click.prevent="docSuggesttionsHandler">
									<li v-for="software in softwareTree">
										<div class="doc-suggestions__item" :class="{ 'has-list': software.versions }">
											<a href="#" :id="'software_' + software.id" class="vol">
												<span>{{ software.name }}</span>
											</a>
										</div>
										<ul v-if="software.versions">
											<li v-for="version in software.versions">
												<div class="doc-suggestions__item" :class="{ 'has-list': version.docs }">
													<a href="#" :id="'version_' + version.id">
														<span>{{ version.name }}</span>
													</a>
												</div>
												<ul v-if="version.docs">
													<li v-for="document in version.docs">
														<div class="doc-suggestions__item" :class="{ 'has-list': document.pages }">
															<a href="#" :id="'document_' + document.id" class="list">
																<span>{{ document.name }}</span>
															</a>
														</div>
														<ul v-if="document.pages">
															<li v-for="page in document.pages">
																<div class="doc-suggestions__item" :class="{ 'has-list': page.child }">
																	<a href="#" :id="'page_' + page.id" class="doc">
																		<span>{{ page.title }}</span>
																	</a>
																</div>
																<ul v-if="page.child">
																	<li v-for="child in page.child">
																		<div class="doc-suggestions__item">
																			<a href="#" :id="'child_' + child.id" class="doc">
																				<span>{{ child.title }}</span>
																			</a>
																		</div>
																	</li>
																</ul>
															</li>
														</ul>
													</li>
												</ul>
											</li>
										</ul>
									</li>
								</ul>
							</div>
						</div>
					</div>

          <div class="mb-4">
            <documentation-file-upload-element
                v-if="type === 'update'"
                v-bind:article_id="this.article_id"
                v-bind:route_get_documents="route_get_documents"
                v-bind:max_file_upload_size="this.max_file_upload_size"
                v-bind:valid_file_size="this.valid_file_size"
                @fileUpload="fileUpload"
                :multiple_property="true">
            </documentation-file-upload-element>
          </div>
                     <div class="row mb-4">
                          <div class="col-12">
                               <div class="form-label">Текст статьи</div>
							   <TinyMCE
									:key="editorIndex"
									:init="editorConfig"
									v-model="content"
							   />
                          </div>
                     </div>
                     <div class="mt-5 mb-4" :class="{'d-none': !previewOpen}">
						<div class="document">
							<div class="document-hat">
								<svg class="document-hat__icon" width="16" height="16" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M5.5 7a.5.5 0 100 1h5a.5.5 0 000-1h-5zM5 9.5a.5.5 0 01.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 2a.5.5 0 01.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5z"
										fill="currentColor" />
									<path
										d="M9.5 0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0011 4.5h2V14a1 1 0 01-1 1H4a1 1 0 01-1-1V2a1 1 0 011-1h5.5z"
										fill="currentColor" />
								</svg>
								{{ pageName }}
							</div>
							<div class="document-content document-content_preview" ref="documentPreviewContent">
							</div>
						</div>
					</div>

					<div class="d-flex flex-column flex-lg-row justify-content-between">
						<button class="btn btn-primary mb-2 mb-lg-0 me-lg-2" @click.prevent="preview">
							<span v-if="previewOpen">Скрыть предпросмотр</span>
							<span v-else="previewOpen">Предпросмотр</span>
						</button>
						<button class="btn btn-success mb-2 mb-lg-0 me-lg-2" @click.prevent="savePage(1)">
							<span>Сохранить и опубликовать</span>
						</button>
						<button class="btn btn-success mb-2 mb-lg-0 me-lg-auto" @click.prevent="savePage(0)">
							<span>Сохранить</span>
						</button>
						<button class="btn btn-lg btn-outline-dark" @click.prevent="cancel">
							<span>Отменить</span>
						</button>
					</div>
				</div>
			</div>
		</div>
    </div>
	<Alert />
</template>

<script>
import '/tinymce/tinymce.min.js';
import '/tinymce/icons/default/icons.min.js';
import '/tinymce/themes/silver/theme.min.js';
import '/tinymce/models/dom/model.min.js';
import TinyMCE from '@tinymce/tinymce-vue';
import axios from 'axios';
import DocumentationFileUploadElement from '../../../elements/documentation/FileUploadElement.vue'
import Alert from '../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: 'CreatePageDocumentationComponent',
	components: {
		DocumentationFileUploadElement,
		TinyMCE,
		Alert,
	},
    props: [
		'type',
		'element',
		'elementdetail',
		'softwarelist',
		'article_id',
		'max_file_upload_size',
		'valid_file_size',
		'route_get_documents',
		'document_base_url',
		'tinymce_keys'
    ],
    data: function() {
        return {
            softwareOptions: [],
            softwareTree: [],
            pageSoftware: {label: ''},
            pageId: '',
            pageName: '',
            pageText: '',
            pageSoftwareSelected: '',
            pageVisible: true,
            previewOpen: false,
            suggestionsOpen: false,
            parentDoc: '',
            parentDocValue: '',
            parentDocIcon: '',
            content: '',
            link_list: [],
            alertMessage: '',
			tinymceKeys: [
                this.tinymce_keys.primary,
                this.tinymce_keys.spare
            ],
            editorIndex: 0,
            keyIndex: null,
        };
    },
	computed: {
        editorConfig() {
            return {
                language: 'ru',
                base_url: '/tinymce',
                suffix: '.min',
                plugins: [
                    'image', 'autoresize', 'code', 'media', 'autolink',
                    'table', 'lists', 'preview', 'link'
                ],
                toolbar1:
                    'newdocument | insertfile undo redo | bold italic underline strikethrough | ' +
                    'alignleft aligncenter alignright alignjustify | cut copy paste link | numlist bullist | ' +
                    'tabulation outdent indent | image media | code | table styleselect formatselect fontselect fontsizeselect | ' +
                    'removeformat | preview',
                toolbar_mode: 'wrap',
                toolbar_sticky: true,
				toolbar_sticky_offset: 84,
                min_height: 400,
                image_advtab: true,
                file_picker_types: 'file image media',
                default_link_target: '_blank',
                link_context_toolbar: true,
                relative_urls: false,
                remove_script_host: false,
                link_title: false,
                document_base_url: this.document_base_url,
                paste_as_text: false,
                paste_data_images: true,
                paste_merge_formats: false,
                valid_elements: '*[*]',
                paste_webkit_styles: 'all',
                link_list: async (success) => {
                    const links = await this.fetchLinkList();
                    success(links);
                },
                setup: (editor) => {
                    this.editorInstance = editor;

                    editor.ui.registry.addButton('tabulation', {
                        icon: 'chevron-right',
                        tooltip: 'Отступ строки',
                        onAction: () => {
                            editor.execCommand('mceInsertContent', false, '&nbsp;&nbsp;&nbsp;&nbsp;');
                        }
                    });
                },
                images_upload_handler: this.uploadFunction,
            };
        }
    },
	created() {
		if(this.softwarelist.length > 0) {
			var list = [];
			this.softwarelist.forEach(obj => {
				list.push({
					value: obj.id,
					label: obj.name
				})
			});
			this.softwareOptions = list;
		};
    },
    methods: {
		...mapMutations('alerts', ['addAlert']),
        fetchLinkList: async function () {
            const response = await axios.get(this.route_get_documents, {
                params: {
                    id: this.article_id
                }
            });
            return response.data;
        },
		uploadFunction: function(blobInfo, success, failure) {
			return new Promise((resolve, reject) => {
				const FormRequest = new FormData();
				FormRequest.append('image', blobInfo.blob());
				let imgUrl = null;
				axios.post('/technical/letter-constructor/upload', FormRequest).then((res) => {
					if(res.data.status == 'ok') {
						imgUrl = res.data.url;
						resolve(imgUrl);
					}
				});
			})
		},
		testFunction: function (FormRequest) {
			return new Promise((resolve, reject) => {

				axios.post('/technical/letter-constructor/upload', FormRequest)
					.then(res => {
						if(res.data.status == 'ok') {
							resolve(res.data.url);
						} else {
							this.addAlert({ type: 'error', title: 'Ошибка', text: res.data.message });
                            reject("Upload failed");
						}
					})
					.catch(err => {
						reject("Upload failed");
					})
			})
		},
		docSuggesttionsHandler: function (e) {
            const target = e.target;
            if (target.classList.contains('has-list')) {
                target.classList.toggle('open');
            } else {
                const link = target.closest('a') || false;
                if (link) {
                    const text = link.textContent;
                    const value = link.id;
                    const icon = link.classList[0] || false;
                    if (text) {
                        this.parentDoc = text;
                    }
					if (value) {
                        this.parentDocValue = value;
                    }
                    if (icon) {
                        this.parentDocIcon = `icon ${icon}`;
                    } else {
                        this.parentDocIcon = '';
                    }
                    this.closeSuggestions();
                }
            }
        },
        resetChoice: function (e) {
            this.parentDocIcon = '';
            e.target.parentElement.setAttribute('class', 'search-control doc-search-control');
            this.openSuggestions();
        },
        openSuggestions: function () {
            this.suggestionsOpen = true;
        },
        closeSuggestions: function () {
            this.suggestionsOpen = false;
        },
		itemGet: async function () {
             this.pageId = this.elementdetail.id;
             this.pageName = this.elementdetail.title;
             this.pageText = this.elementdetail.text;
             this.pageSoftware = this.elementdetail.sw_id ? {value: this.elementdetail.sw_id, label: this.elementdetail.sw_name} : null;
             this.pageSoftwareSelected = this.elementdetail.sw_id;
             this.pageVisible = (this.elementdetail.visible == 0) ? false : true;

             axios.post('/docs-edit/software-tree', {sw_id: this.elementdetail.sw_id})
                 .then(res => {
                      this.softwareTree = res.data.softwareTree;
                      this.parentDoc = this.elementdetail.parent.name;
                      this.parentDocValue = this.elementdetail.parent.value;
                      this.parentDocIcon = this.elementdetail.parent.icon;
                 });
        },
		cancel: function () {
			document.location = '/docs-edit';
		},
		savePage: function (visible) {
			var pageData = {
				type: this.type,
				name: document.getElementById('pageNameInput').value,
				text: this.content,
				parent: this.parentDocValue,
				visible: visible
			};
			if(this.type == 'update') {
				pageData.id = document.getElementById('pageIdInput').value;
			}
			axios.post('/docs-edit/page', pageData)
				.then(res => {
					if(res.data.status == 'error') {
						var error_list = '<h5>При добавлении статьи произошли следующие ошибки:</h5><ul>';
						res.data.errors.forEach(error => {
							error_list += '<li>' + error + '</li>'
						});
						error_list += '</ul>';
						document.getElementById('response_errors').innerHTML = error_list;
						document.getElementById('response_errors').style.display = 'block';
						document.getElementById('response_errors').scrollIntoView({behavior: "smooth"});
					} else if(res.data.status == 'ok') {
						document.location = '/docs-edit/page/' + res.data.page_id;
					}
				});
		},
		onPageSoftwareChange(events) {
			this.pageSoftwareSelected = events.value;
			axios.post('/docs-edit/software-tree', {sw_id: events.value})
				.then(res => {
					this.softwareTree = res.data.softwareTree;
					this.parentDoc = '';
					this.parentDocValue = '';
					this.parentDocIcon = '';
				}
			);
		},
		preview: function () {
             this.previewOpen = !this.previewOpen;
             if (this.previewOpen) {
                  this.$refs.documentPreviewContent.innerHTML = this.content;
             } else {
                  this.$refs.documentPreviewContent.innerHTML = '';
             }
        },
    },
    mounted() {
		localStorage.setItem('prevPageUrl', window.location.href)
		if (this.article_id) this.itemGet();
		if(this.pageText !== undefined) {
			this.content = this.pageText;
		}
    },
};
</script>
